module.exports = __webpack_public_path__ + "img/girl_black_mask.4a1d1e84.png";